if (!customElements.get('wls-footer')) {
    class WLSFooter extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                openClass: 'open',
                accordion: 'js-wls-footer-accordion',
                isMobile: window.innerWidth <= 1199,
            };
            this.elements = {
                accordions: this.querySelectorAll(`.${this.classes.accordion}`)

            }
        }

        connectedCallback() {
            this.handleAccordions();
            this.handleNewsletterForm();
        }

        handleAccordions() {
            if (this.classes.isMobile && this.elements.accordions.length > 0) {
                this.elements.accordions.forEach(acc => {
                    acc.addEventListener('click', () => {
                        acc.classList.toggle(this.classes.openClass);
                    })
                })
            }
        }

        handleNewsletterForm() {
            const form = this.querySelector('.js-wls-newsletter-form');
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                const formData = new FormData(form);
                const email = formData.get('contact[email]');
                

                fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
                    headers: {
                        accept: 'application/json, text/plain, */*',
                        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    },
                    body: new URLSearchParams({g: 'TSDA9r', email: email}),
                    method: 'POST',
                })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                })
                .catch(error => {
                    console.error('Error:', error);
                });
            })
        }
    }

    customElements.define('wls-footer', WLSFooter);
}